import React from "react";

const PageNotFound = function () {
  return <h1>Oops! Page Not Found</h1>;
};

export default PageNotFound;
